import { SET_COUNT } from '../../constants/ActionTypes';

const INIT_STATE = {
  count: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_COUNT: {
      return {
        ...state,
        count: action.payload,
      };
    }

    default:
      return state;
  }
};
